import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service'
import { ToastrService } from 'ngx-toastr';
import { I18nModule } from '@spartacus/core';
@Component({
    selector: 'app-tender-cancel-bid',
    templateUrl: './tender-cancel-bid.component.html',
    styleUrls: ['./tender-cancel-bid.component.scss'],
    imports: [I18nModule]
})
export class TenderCancelBidComponent implements OnInit {
  private modalRef: NgbModalRef;
  productInfo: any;
  @Input() productsInfo:any;
  @Input() price:number;
  biddingTerms = '';
  requestParams: any;
  reqTenderEntries:any = [];
  @Output() refreshList = new EventEmitter<string>();

  constructor(private customProductService: CustomProductsService,private router:Router,public ActiveModal: NgbActiveModal,private customProductsService: CustomProductsService,private toastrService: ToastrService) { }

  ngOnInit(): void {
    this.productInfo=this.productsInfo.quoteEntries;
    console.log(this.productInfo);
    // if(this.productInfo.length>1){
    //   this.productInfo.map((val)=>{
    //     this.reqTenderEntries.push({
    //     "quoteAction": "CANCELLED",
    //     "tender": {
    //       "otherBindingTerms": "string_1",   
    //       "quoteCode": val.quoteCode,
    //       "tenderEntries": [
    //         {  "entryNumber": 0,
    //           "maximumQuantity": val.product.maximumQty,
    //           "minimumQuantity": val.product.minimumQty,
              
    //           "pricingBasis": {
    //               "code": val.pricingBasis.code,
    //               "description": val.pricingBasis.description
    //           },
    //           "pricingOptionsEnum": [
    //             {
    //               "pricingOptions": val.pricingOptionsEnum[0].pricingOptions
    //             }
    //           ],
    //           "productCode": val.productCode,
    //           "productName": val.productName,
    //           "quantity": val.quantity,
      
    //           "quotationPeriod": {
    //               "code": val.defaultQuotationPeriod.code,
    //               "description": val.defaultQuotationPeriod.description
    //             },
    //           "relativePrice": {
    //             "currencyIso": val.relativePrice.currencyIso,
    //             "value": val.relativePrice.value
    //           }
    //         }
    //       ]
    //     }
    //   })
    // })
    // }else{
    //   this.requestParams={
    //     "quoteAction": "CANCELLED",
    //     "tender": {
    //       "quoteCode": this.productInfo.quoteCode,
    //     }
    //   }
    // }
 
  }
  close(): any {
    this.ActiveModal.close();
  }
  cancelbid(){
    // if(this.productInfo.length>1){
    //   this.requestParams = {
    //     "quoteAction": "CANCELLED",
    //     "tender": {
    //       "otherBindingTerms": "string_1",   
    //       "quoteCode": this.productInfo.quoteCode,
    //       "tenderEntries": this.reqTenderEntries
    //     }
    //   }
    // }else
    {
      this.requestParams={
        "quoteAction": "CANCELLED",
        "tender": {
          "quoteCode": this.productsInfo.quoteCode,
        }
      }
    }
 
    console.log(this.requestParams);
    this.customProductsService.submitTender(this.requestParams).subscribe(resp=>{
      console.log(resp);
      if(resp.status === 'CANCELLED'){
        // this.toastrService.show('Your bid has been cancelled');
        this.customProductService.cancelled = true;
        this.ActiveModal.close();
        this.refreshList.emit(resp)
        this.router.navigate([`/quotes/myquotes`]);
      }else{
        this.toastrService.show(resp.status);
      }
      
    },
    err=>{
      console.log(err);
      this.ActiveModal.close();
      this.toastrService.show(err?.error.errors?err.error.errors[0].message:'Something went wrong while submitting the tender, please contact support team');
    })
  }

}
